import { MgService } from 'src/app/services/mg.service';
import { Attachment } from './../../../models/attachment.model';
import { Component, Input, OnInit } from '@angular/core';
import { Item } from 'src/app/models/item.model';

@Component({
  selector: 'app-call-entry-item-response',
  templateUrl: './call-entry-item-response.component.html',
  styleUrls: [
    './../../../../assets/scss/call-screen.scss',
    './call-entry-item-response.component.scss'
  ]
})
export class CallEntryItemResponseComponent implements OnInit {
  @Input() item: Item;

  private acceptMimeTypes = [
    "image/x-png",
    "image/png",
    "image/gif",
    "image/jpeg",
    "application/pdf",
    "application/json",
    "application/xml",
    "image/webp",
    "text/xml",
    ".png",
  ];

  constructor(
    private mg: MgService
  ) { }

  ngOnInit(): void {
  }

  public get showName(): string {
    let user = this.item.user.name.split(' ');
    return user[0]
  }

  public downloadFile(file: Attachment) {
    this.mg.downloadCallFile(file.path)
    .subscribe(
      res => {
        const blob = new Blob([res], { type: res.type });
        var downloadURL = window.URL.createObjectURL(blob);
        var link = document.createElement('a');

        if(this.acceptMimeTypes.includes(res.type)) {
          window.open(downloadURL);
        } else {
          link.href = downloadURL;
          link.download = file.name;
          link.click();
        }
      }
    )
  }

}
